import Axios from "../../Config/API";
import {
    vincularUsuarioGrupo,
    GrupoVinculadoUsuarioInterface,
    usuarioGrupo,
} from "../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import Service from "../../Service";

export async function VincularGruposUsuarioService(
    requestBody: vincularUsuarioGrupo[]
) {
    return Service(
        Axios.post(`/home/gruposusuario/vinculargruposusuario`, requestBody)
    );
}

export async function DesVincularGruposUsuarioService(
    idGrupoUsuario: number[]
) {
    return Service(
        Axios.put(`home/gruposusuario/desvinculargruposusuario`, idGrupoUsuario)
    );
}

export async function ListarGruposVinculadosPorUsuarioService(
    idUsuario: number
) {
    return Service(
        Axios.get<Array<GrupoVinculadoUsuarioInterface>>(
            `/home/gruposusuario/listargruposvinculadosporusuario?IDUsuario=${idUsuario}`
        )
    );
}

export async function ListarGruposNaoVinculadosPorUsuarioService(
    idUsuario: number
) {
    return Service(
        Axios.get<Array<GrupoVinculadoUsuarioInterface>>(
            `/home/gruposusuario/listargruposnaovinculadosporusuario?IDUsuario=${idUsuario}`
        )
    );
}

export async function ListarUsuariosPorGrupoService(idGrupo: number) {
    return Service(
        Axios.get<Array<usuarioGrupo>>(
            `/home/gruposusuario/listarusuariosvinculadosporgrupo?IDGrupo=${idGrupo}`
        )
    );
}

export async function ListarUsuariosPorGrupoNaoVinculadosService(
    IDGrupo: number
) {
    return Service(
        Axios.get<Array<usuarioGrupo>>(
            `home/gruposusuario/listarusuariosnaovinculadosporgrupo?IDGrupo=${IDGrupo}`
        )
    );
}

export async function DesVincularUsuarioGrupoService(
    idGrupo: number,
    requestBody: number[]
) {
    return Service(
        Axios.put<Array<usuarioGrupo>>(
            `/home/gruposusuario/desvincularusuariosgrupo?idGrupo=${idGrupo}`,
            requestBody
        )
    );
}
